import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import MoneyflowTrackersModule, {
  MoneyflowTrackersModuleStateProps,
  MoneyflowTrackersModuleOwnProps,
} from 'components/features/pfm/MoneyflowTrackersModule/MoneyflowTrackersModule'

const mapStateToProps = (state: State, { type }: MoneyflowTrackersModuleOwnProps): MoneyflowTrackersModuleStateProps => {
  const { trackers } = state.data[type]

  return {
    isShown: !trackers || trackers.allKeys.length > 0,
  }
}

const MoneyflowTrackersModuleContainer = connect<
  MoneyflowTrackersModuleStateProps,
  {},
  MoneyflowTrackersModuleOwnProps
>(mapStateToProps)(MoneyflowTrackersModule)

export default MoneyflowTrackersModuleContainer
